import type { SubstanceRow } from "../_model";

interface StockCellProps {
  substance: SubstanceRow;
  dense?: boolean;
}

export function StockCell({ substance }: StockCellProps) {
  const st = substance.stock;
  if (!st) {
    return <span style={{ fontSize: 11, color: "var(--ink-mute)" }}>—</span>;
  }
  return (
    <div className="vstack" style={{ gap: 1, minWidth: 0 }}>
      <div className="hstack" style={{ gap: 6, minWidth: 0 }}>
        <span style={{
          width: 7, height: 7, borderRadius: "50%", flexShrink: 0,
          background: st.inStock ? "var(--brand-lime)" : "var(--line-strong)",
        }} />
        <span style={{ fontSize: 12, color: st.inStock ? "var(--ink-2)" : "var(--ink-4)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {st.supplier}
        </span>
      </div>
      <div className="mono" style={{ fontSize: 10, color: "var(--ink-4)", letterSpacing: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingLeft: 13 }}>
        {st.lot} · {st.size}{st.price > 0 ? ` · $${st.price.toFixed(0)}` : ""}
      </div>
    </div>
  );
}
